// @flow
import client from '../../client'
import format from '../../utils/format'

// Type
import type { TrackingVehicleInfo, OndemandReservation } from '../../api_types'

// API Endpoints
export const RIDE_VEHICLE_INFORMATION = '/reservations/{0}/vehicle/'
export const ONDEMAND_RIDE_VEHICLE_INFORMATION = '/ondemand/reservations/{0}/'
export type DataRequest = {
  id: string,
  ondemand?: boolean,
}

/**
 * Get prebook vehicle and driver information for a pickup
 * @param  {Object} data Reservation tracking information
 * @param  {string} data.id Hashed id of the reservation
 * @return {Promise|Error} A resolved Promise with vehicle and driver information for the pickup.
 */
export const getPrebookInfo = (
  data: DataRequest
): Promise<?TrackingVehicleInfo> => {
  const endpoint = format(RIDE_VEHICLE_INFORMATION, data.id)
  return client.get(endpoint)
}

/**
 * Get prebook vehicle and driver information for a pickup
 * @param  {Object} data Reservation tracking information
 * @param  {string} data.id Hashed id of the reservation
 * @return {Promise|Error} A resolved Promise with vehicle and driver information for the pickup.
 */
export const getOndemandInfo = (
  data: DataRequest
): Promise<?TrackingVehicleInfo> => {
  const endpoint = format(ONDEMAND_RIDE_VEHICLE_INFORMATION, data.id)
  return client.get(endpoint).then((response: OndemandReservation) =>
    !response || !response.ride || !response.ride.driver
      ? null
      : {
          status: response.status,
          driver: response.ride.driver,
          vehicle: response.ride.vehicle,
        }
  )
}

const getInfo = (data: DataRequest): Promise<?TrackingVehicleInfo> =>
  data.ondemand ? getOndemandInfo(data) : getPrebookInfo(data)

export default getInfo
